import { createSelector } from 'reselect'
import storeCarouselSelector from './store_carousel_selector'
import storeWidgetsSelector from './store_widgets_selector'

const getStore = state => state.store
const getUI = state => state.ui

const storeLandingContainerSelector = createSelector(
	[ getStore, getUI, storeCarouselSelector, storeWidgetsSelector ],
	(storeData, uiData, carouselData, widgetsData) => {

		let storefrontBar = ''
		if (storeData.catalog && storeData.catalog.storefrontBar) {
			storefrontBar = storeData.catalog.storefrontBar
		}

		return {
			query: storeData.query,
			storefrontBar,
			carouselEntities: carouselData.entities,
			widgets: widgetsData.widgets,
			widgetTabs: widgetsData.widgetTabs,
			showAllWidgets: widgetsData.showAllWidgets,
			containerWidth: uiData.width,
		}
	}
)

export default storeLandingContainerSelector
